import * as React from "react";
import { store } from "../store";
import { StoreState } from "../reducers";
import get from "lodash/get";

const IFRAME_PROLOGUE = "[iFrameSizer]message:";

const extractIframeResizerMessage = (messageData: string) =>
  messageData.startsWith(IFRAME_PROLOGUE)
    ? JSON.parse(messageData.replace("[iFrameSizer]message:", ""))
    : messageData;

export class MessageReceiver extends React.Component {
  componentDidMount() {
    window.addEventListener("message", this.handleFrameMessage);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleFrameMessage);
  }

  // tslint:disable-next-line:no-any
  handleFrameMessage = (message: any) => {
    // Messages may arrive either directly to the iframe or via iFrameResizer.
    const messageContent =
      typeof message.data === "string"
        ? extractIframeResizerMessage(message.data)
        : message.data;

    const storeState = store.getState() as StoreState;
    const widgetType = get(storeState, "settings.designType", "");

    if (messageContent.type) {
      if (
        // Dashboards need to confirm auth before hydrating the customer object
        // dispatches if either customer.authenticated or legacyWidgetCustomerData.authenticated is true
        messageContent.type === "SESSION_DATA_UPDATE" &&
        widgetType === "dashboard" &&
        !get(messageContent, "data.customer.authenticated", false) &&
        !get(
          messageContent,
          "data.legacyWidgetCustomerData.authenticated",
          false
        )
      ) {
        return;
      }

      store.dispatch(messageContent);
    }
  };

  render() {
    return null;
  }
}
